import * as cardManagement from '../services/cardManagement';

export default {
  namespace: 'cardManagement',
  state: {},
  effects: {
    //卡面列表
    *queryStoreCardPage({ payload: { values }, callback }, { call, put }) {
      const response = yield call(cardManagement.queryStoreCardPage, values);
      yield put({
        type: 'save',
        payload: {
          cardData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *activityDelete({ payload: { values }, callback }, { call }) {
      const response = yield call(cardManagement.activityDelete, values);
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
